module.exports = {"520627001":"团结街道","520627002":"和平街道","520627003":"沙子街道","520627101":"黑水镇","520627102":"谯家镇","520627103":"夹石镇","520627104":"淇滩镇","520627105":"官舟镇","520627106":"土地坳镇","520627107":"思渠镇","520627108":"客田镇","520627109":"洪渡镇","520627110":"中界镇","520627111":"甘溪镇","520627112":"板场镇","520627113":"泉坝镇","520627114":"中寨镇","520627115":"黄土镇","520627116":"新景镇","520627117":"塘坝镇","520627203":"晓景乡","520627211":"后坪乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/520627.json
// module id = 2499
// module chunks = 0